import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import SVGIcon from '../SVGIcon/SVGIconGenerator';
import moment from 'moment';
import { updateOpenOrClosedForWA, getWaitingArea } from '../../../actions/waitingArea';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';

@connect()
export default class StatusIndicatorForPIWA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countdownSeconds: this.props.status.secondsRemainForClosing || 0,
    };
  }
  componentWillMount = () => {
    clearInterval(this.intervalTimer);
    clearTimeout(this.timeoutTimer);
    this.timeoutTimer = null;
    this.intervalTimer = null;
  };

  componentWillUnmount = () => {
    clearInterval(this.intervalTimer);
    clearTimeout(this.timeoutTimer);
    this.timeoutTimer = null;
    this.intervalTimer = null;
  };

  getCurrentUTC = () => {
    return moment.utc();
  };

  /* When needs to display Closing soon message, this countdown function will be triggered */
  /* Seconds will be decreased by 1 every second */
  setUpTheIntervalTimer = () => {
    clearTimeout(this.timeoutTimer);
    clearInterval(this.intervalTimer);
    var currentTime = this.getCurrentUTC();
    if (currentTime.isSameOrBefore(this.props.status.nextCloseTime)) {
      // // Check the seconds left for next close time
      let countdownSeconds = this.props.status.nextCloseTime.diff(currentTime, 'seconds');
      // // Safety check in case it returns negative no. and ensure the countdown should not larger than 900;
      // countdownSeconds = Math.abs(countdownSeconds);
      let countdown = () => {
        currentTime = this.getCurrentUTC();
        // Check the seconds left for next close time
        countdownSeconds = this.props.status.nextCloseTime.diff(currentTime, 'seconds');
        // Safety check in case it returns negative no. and ensure the countdown should not larger than 900;
        countdownSeconds = countdownSeconds > 0 ? countdownSeconds - 1 : 0;
        if (countdownSeconds <= 0) {
          // It time hits the last second (which means the WA is closed at this second)
          this.setState(
            {
              countdownSeconds: countdownSeconds,
            },
            () => {
              this.props.dispatch(updateOpenOrClosedForWA(this.props.waitingAreaId, false));
              queueESEvents(
                ESEventTypes.APICall,
                `In StatusIndicatorForPIWA: ${this.props.waitingAreaId}`,
                'eventType&apiURL',
                {
                  apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + this.props.waitingAreaId + '/calls',
                  browserURL: window.location.href,
                },
                null,
                true,
                'info'
              );
              this.props.dispatch(getWaitingArea(this.props.waitingAreaId));
              clearInterval(this.intervalTimer);
              this.intervalTimer = null; // Need to add this one for checking if interval timer is running
            }
          );
        } else {
          this.setState({
            countdownSeconds: countdownSeconds,
          });
        }
      };
      if (countdownSeconds <= this.props.messageThresholdMinutes * 60 && countdownSeconds >= 0) {
        this.intervalTimer = setInterval(countdown, 100);
      }
    } else {
      return;
    }
  };

  /* When WA is closed or is open but not closing soon, this function will be triggered */
  /* It will respond when the time hits the closing soon time, or the times hits the open moment from closed */
  setUpTimeoutTimer = () => {
    clearInterval(this.intervalTimer);
    this.intervalTimer = null;
    clearTimeout(this.timeoutTimer);
    this.timeoutTimer = null;
    // if isOpen - timeout to next closed timeout;
    var currentTime = this.getCurrentUTC();
    // Check the seconds left for next close time
    if (this.props.status.isOpen) {
      let timeoutSeconds = currentTime.diff(this.props.status.nextCloseTime, 'seconds');
      // Safety check in case it returns negative no.
      timeoutSeconds = Math.abs(timeoutSeconds);
      let timeoutForClosed = () => {
        this.props.dispatch(updateOpenOrClosedForWA(this.props.waitingAreaId, false));
      };
      this.timeoutTimer = setInterval(timeoutForClosed, timeoutSeconds * 1000);
    } else if (!this.props.status.isOpen) {
      // if isClosed - timeout to next open timeout;
      let timeoutSeconds = this.props.status.nextOpenTime.diff(currentTime, 'seconds');
      // Safety check in case it returns negative no.
      timeoutSeconds = Math.abs(timeoutSeconds);
      let timeoutForOpen = () => {
        clearInterval(this.intervalTimer);
        this.intervalTimer = null;
        this.props.dispatch(updateOpenOrClosedForWA(this.props.waitingAreaId, true));
        queueESEvents(
          ESEventTypes.APICall,
          `In StatusIndicatorForPIWA 2: ${this.props.waitingAreaId}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + this.props.waitingAreaId + '/calls',
            browserURL: window.location.href,
          },
          null,
          true,
          'info'
        );
        this.props.dispatch(getWaitingArea(this.props.waitingAreaId));
        this.setState({
          countdownSeconds: this.props.messageThresholdMinutes * 60,
        });
      };
      this.timeoutTimer = setInterval(timeoutForOpen, timeoutSeconds * 1000);
    }
  };

  getNextOpenDayAndTime = (momentObject) => {
    // This chunk of code is used for display the next open day and time in system timezoneOffset
    // Get offset
    let timezoneOffset = this.props.timezone == null ? 0 : this.props.timezone;
    let momentObjectCalculatedByTimezone = momentObject.utcOffset(this.props.timezone);

    // Check if next open on the same day
    let nextOpenWithinToday = moment().utcOffset(timezoneOffset).isSame(momentObjectCalculatedByTimezone, 'day');

    let dayNumber = momentObjectCalculatedByTimezone.day();
    let openTime = {
      hour: momentObjectCalculatedByTimezone.hour(),
      minute: momentObjectCalculatedByTimezone.minute(),
    };
    let nextOpenDay = moment(dayNumber, 'e').format('dddd');
    let nextOpenTime = moment(openTime).format('h:mm a');
    return {
      nextOpenWithinToday: nextOpenWithinToday,
      nextOpenDay: nextOpenDay,
      nextOpenTime: nextOpenTime,
    };
  };

  render() {
    if (!this.props.status.isOpen) {
      // Is Closed
      let nextOpenTimeObject = this.getNextOpenDayAndTime(this.props.status.nextOpenTime);
      this.setUpTimeoutTimer();
      if (nextOpenTimeObject.nextOpenWithinToday) {
        // Only show reopen time
        return (
          <div className="row flexible row-hoverable  center-text pointer color-right-hand-side-panel-bg">
            <div className="inline-flex center-flex pdlm pdrm">
              <Icon name="minus circle" size="big" className="waiting-area-red" style={{ marginRight: '10px' }} />
              <div
                className="column text-size-m left-text"
                dangerouslySetInnerHTML={{
                  __html: APP.LANGUAGE.ViewOneWaitingArea.WAReopenTimeWarning.replace(
                    '##ReopenTime##',
                    `at ${nextOpenTimeObject.nextOpenTime}`
                  ),
                }}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div className="row flexible row-hoverable  center-text pointer color-right-hand-side-panel-bg">
            <div className="inline-flex center-flex pdlm pdrm">
              <Icon name="minus circle" size="big" className="waiting-area-red" style={{ marginRight: '10px' }} />
              <div
                className="column text-size-m left-text"
                dangerouslySetInnerHTML={{
                  __html: APP.LANGUAGE.ViewOneWaitingArea.WAReopenTimeWarning.replace(
                    '##ReopenTime##',
                    `at ${nextOpenTimeObject.nextOpenTime} on ${nextOpenTimeObject.nextOpenDay}`
                  ),
                }}
              />
            </div>
          </div>
        );
      }
    } else if (this.props.status.isClosingSoon) {
      // Closing soon
      this.setUpTheIntervalTimer();
      // Closing within 60 seconds
      if (this.state.countdownSeconds <= 60 && this.state.countdownSeconds > 0) {
        let secondString =
          this.state.countdownSeconds === 1
            ? `${this.state.countdownSeconds} second`
            : `${this.state.countdownSeconds} seconds`;
        // Closing soon
        return (
          <div className="row flexible row-hoverable  center-text pointer color-right-hand-side-panel-bg">
            <div className="inline-flex center-flex pdlm pdrm">
              <i
                aria-hidden="true"
                className="big icon"
                style={{
                  marginRight: '10px',
                }}
              >
                <SVGIcon name="clock" height={34} SVGprops={{ fill: '#f6af69' }} />
              </i>
              <div
                className="column text-size-m left-text"
                dangerouslySetInnerHTML={{
                  __html: APP.LANGUAGE.ViewOneWaitingArea.WAClosingTimeWarning.replace(
                    '##ClosingTime##',
                    `${secondString}`
                  ),
                }}
              />
            </div>
          </div>
        );
      } else if (
        this.state.countdownSeconds <= this.props.messageThresholdMinutes * 60 &&
        this.state.countdownSeconds > 60
      ) {
        return (
          <div className="row flexible row-hoverable  center-text pointer color-right-hand-side-panel-bg">
            <div className="inline-flex center-flex pdlm pdrm">
              <i
                aria-hidden="true"
                className="big icon"
                style={{
                  marginRight: '10px',
                }}
              >
                <SVGIcon name="clock" height={34} SVGprops={{ fill: '#f6af69' }} />
              </i>
              <div
                className="column text-size-m left-text"
                dangerouslySetInnerHTML={{
                  __html: APP.LANGUAGE.ViewOneWaitingArea.WAClosingTimeWarning.replace(
                    '##ClosingTime##',
                    `${Math.ceil(this.state.countdownSeconds / 60)} minutes`
                  ),
                }}
              />
            </div>
          </div>
        );
      }
    } else {
      clearInterval(this.intervalTimer);
      clearTimeout(this.timeoutTimer);
      this.timeoutTimer = null;
      this.intervalTimer = null;
    }
    // Is open and not closing soon
    return '';
    // should not show anything
  }
}
